<template>
    <g-typography :value="addedDateString" margins />
</template>

<script>
    import { pluralize } from '../../../../../helpers/string-helpers';
    import moment from 'moment-timezone';
    import {
        ACTIVATION_ORDER_SHIPMENT_STATUS_LABELS,
        ACTIVATION_ORDER_SHIPMENT_STATUS_NONE
    } from '../../../../../constants/activation-brief-shipment-status';
    import { ACTIVATION_ORDER_FULFILLMENT_STATUS_LABELS } from '../../../../../constants/activation-brief-fulfillment-status';

    export default {
        name: 'OrderStatusInfo',
        props: {
            brief: {
                type: Object,
                required: true
            },
            order: {
                type: Object,
                required: true
            }
        },
        computed: {
            itemCountString() {
                const count = this.order.items.length;
                return `${count} ${pluralize(count, 'Item')}`;
            },
            addedDateString() {
                if (
                    !this.brief.brand.ecommerce_account ||
                    (this.order.is_fulfilled && this.order.shipment_status === ACTIVATION_ORDER_SHIPMENT_STATUS_NONE)
                ) {
                    return `Added ${moment(this.order.created_at).format('MMM D, YYYY')} • ${
                        ACTIVATION_ORDER_FULFILLMENT_STATUS_LABELS[this.order.is_fulfilled]
                    }`;
                }

                return `Added ${moment(this.order.created_at).format('MMM D, YYYY')} • ${
                    ACTIVATION_ORDER_SHIPMENT_STATUS_LABELS[this.order.shipment_status]
                }`;
            }
        }
    };
</script>
